import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { css, up, styled, th } from '@smooth-ui/core-sc';
import { Link } from 'react-router-dom';
import logo from './images/logo.svg';

import { withSettings } from 'containers/WebApp/SettingsContext';

const FooterWrapper = styled.footer`
  background-color: #014df4;
  border-top: 4px solid #fff;
  font-size: 14px;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 2rem 0 1rem 0;
  ${up(
    'md',
    css`
      flex-direction: column;
      justify-content: center;
    `
  )};
  p {
    color: #fff;
    font-size: 14px;
  }
  ul {
    padding-left: 0;
    margin: 0 auto;
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    ${up(
      'md',
      css`
        flex-direction: row;
      `
    )};
  }
  li {
    font-size: 14px;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    ${up(
      'md',
      css`
        padding: inherit;
        text-align: left;
      `
    )};
    a {
      color: #fff;
      text-decoration: none;
      padding: 0.1rem 1rem;
      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }
  }

  .footer-right-text {
    padding: 0 1rem;
  }
`;

const FooterLogo = styled.img`
  display: block;
  margin: 0 auto 1rem;
  width: 105px;
  height: auto;
`;

const TriangleContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  overflow: hidden;

  ${up(
    'md',
    css`
      height: 200px;
    `
  )};

  .back-triangle,
  .front-triangle {
    border-style: solid;
    width: 0;
    height: 0;
    position: absolute;
    bottom: 0;
  }

  .back-triangle {
    border-width: 0px 90vw 80px 0px;
    ${up(
      'md',
      css`
        border-bottom-width: 180px;
      `
    )};
    border-color: transparent transparent ${th('secondary')} transparent;
  }

  .front-triangle {
    right: 0;
    border-width: 0px 0px 100px 120vw;
    ${up(
      'md',
      css`
        border-bottom-width: 200px;
      `
    )};
    border-color: transparent transparent ${th('primary')} transparent;
  }
`;

const Footer = ({ siteName }) => (
  <>
    <TriangleContainer>
      <div className="back-triangle" />
      <div className="front-triangle" />
    </TriangleContainer>
    <FooterWrapper>
      <FooterContainer>
        <FooterLogo src={logo} alt={siteName} />
        <ul>
          <li>
            <Link to="/terms">Terms & Conditions</Link>
          </li>
          <li>
            <Link to="/privacy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/faqs">FAQs</Link>
          </li>
          <li>
            <Link to="/sitemap">Sitemap</Link>
          </li>
        </ul>
      </FooterContainer>
    </FooterWrapper>
  </>
);

Footer.propTypes = {
  siteName: PropTypes.string,
};

Footer.defaultProps = {
  siteName: 'Lori Program Default',
};

export default withSettings(Footer);
